export const GET_MESSAGI_VOCALI_ORIGINE_DATA_AND_LOADING =
  "GET_MESSAGI_VOCALI_ORIGINE_DATA_AND_LOADING";
export const CREATE_UPDATE_DELETE_MESSAGGI_VOCALI_ORIGINE =
  "CREATE_UPDATE_DELETE_MESSAGGI_VOCALI_ORIGINE";
export const EXPORT_MESSAGGI_VOCALI_ORIGINE_LOADING =
  "EXPORT_MESSAGGI_VOCALI_ORIGINE_LOADING";

export const GET_MESSAGGI_VOCALI_ORIGINE_BY_ID =
  "GET_MESSAGGI_VOCALI_ORIGINE_BY_ID";
export const GET_CREATE_MESSAGGI_VOCALI_ORIGINE_DATA =
  "GET_CREATE_MESSAGGI_VOCALI_ORIGINE_DATA";
